import React, { useEffect, useRef, useState } from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft, CheckCircle2, Loader2, Mail } from 'lucide-react';
import { axiosInstance } from '../App';
import AuthLayout from '../components/auth/AuthLayout';

const ForgotPassword = () => {
  const headingRef = useRef(null);
  const [email, setEmail] = useState(new URLSearchParams(window.location.search).get('email') || '');
  const [busy, setBusy] = useState(false);
  const [sent, setSent] = useState(false);
  useEffect(() => headingRef.current?.focus(), []);

  const submit = async (event) => {
    event.preventDefault();
    setBusy(true);
    try {
      await axiosInstance.post('/auth/password-reset/request', { email: email.trim().toLowerCase() });
      setSent(true);
    } catch {
      // Account-recovery responses are deliberately indistinguishable. This
      // also prevents a transient provider error from exposing account state.
      setSent(true);
    } finally { setBusy(false); }
  };

  return (
    <AuthLayout>
      <div className="enterprise-auth-card">
        <div className="enterprise-auth-step">
          <p className="enterprise-auth-kicker">Account recovery</p>
          <h2 ref={headingRef} tabIndex="-1">Reset your password</h2>
          {sent ? <>
            <div className="enterprise-auth-organisation"><CheckCircle2 size={19}/><span>Check your email</span></div>
            <p className="enterprise-auth-intro">If an active password account matches <strong>{email}</strong>, Qflow has sent a single-use reset link. It expires shortly. Check spam or try again after a few minutes.</p>
            <Link className="enterprise-auth-primary enterprise-auth-link-primary" to="/auth">Return to sign in</Link>
            <button type="button" className="enterprise-auth-back" onClick={() => setSent(false)}><ArrowLeft size={16}/>Try another email</button>
          </> : <>
            <p className="enterprise-auth-intro">Enter the email linked to your Qflow account. For security, the result is the same whether or not an account exists.</p>
            <form onSubmit={submit} noValidate>
              <label htmlFor="reset-email">Work email</label>
              <div className="relative"><Mail className="pointer-events-none absolute left-3 top-3 text-slate-400" size={17}/><input id="reset-email" type="email" autoComplete="email" required autoFocus value={email} onChange={event => setEmail(event.target.value)} className="pl-10" placeholder="name@organisation.com"/></div>
              <button className="enterprise-auth-primary" type="submit" disabled={busy || !email.trim()}>{busy ? <><Loader2 className="animate-spin" size={17}/>Sending securely…</> : 'Send reset link'}</button>
            </form>
            <Link className="enterprise-auth-back" to="/auth"><ArrowLeft size={16}/>Back to sign in</Link>
          </>}
        </div>
      </div>
    </AuthLayout>
  );
};

export default ForgotPassword;
